import {
  CustomRepetitionEndOptions,
  CustomRepetitionEndsAfterRepetitions
} from '@hconnect/common/components/repetitiveTask'
import {CustomTaskRepetition} from '@hconnect/common/types'
import {SimpleDatePicker} from '@hconnect/uikit/src/lib2/components/momentDatePicker'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {Box} from '@mui/material'
import moment from 'moment-timezone'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../../consts'

type Props = {
  defaultEnd: moment.Moment
  settings: CustomTaskRepetition
  onChange: (next: CustomTaskRepetition) => void
  plantId: string
}

export const TaskRepetitionEndingOptions: React.FC<Props> = ({
  defaultEnd,
  settings,
  onChange,
  plantId
}) => {
  const timezone = useUpmPlantTimezone(plantId)
  const {t} = useTranslation(FEATURE_NAMESPACE)
  return (
    <>
      <CustomRepetitionEndOptions
        t={t}
        hasEndDate={!!settings.endDate}
        hasEndsAfterRepetitions={!!settings.endsAfterRepetitions}
        onChange={(options) => {
          const next = {...settings}

          delete next.endsAfterRepetitions
          delete next.endDate

          if (options === 'afterCount' && !settings.endsAfterRepetitions) {
            next.endsAfterRepetitions = 2
          }
          if (options === 'onDate' && !settings.endDate) {
            next.endDate = defaultEnd
          }

          onChange(next)
        }}
      />
      {settings.endDate && (
        <Box component={'span'} mx={2}>
          <SimpleDatePicker
            date={settings.endDate}
            timezone={timezone}
            handleDateChange={(date) => {
              if (date) {
                if (!date) return
                const endOfDay = date.endOf('day').subtract(1, 'minute')
                const next = {
                  ...settings
                }
                delete next.endsAfterRepetitions
                next.endDate = endOfDay
                onChange(next)
              }
            }}
          />
        </Box>
      )}
      <CustomRepetitionEndsAfterRepetitions
        t={t}
        value={settings.endsAfterRepetitions}
        onChange={(endsAfterRepetitions) => {
          const next = {
            ...settings
          }
          delete next.endDate
          next.endsAfterRepetitions = endsAfterRepetitions
          onChange(next)
        }}
      />
    </>
  )
}
